import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) {
      toast.success("Account created");
      navigate("/onboarding", { replace: true });
    } else {
      setError(r.error);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24" data-testid="register-page">
      <div className="overline">Get started</div>
      <h1 className="font-display text-4xl text-teal-900 mt-2">Create your Surfmatics account</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-4 card-soft p-6" data-testid="register-form">
        <div>
          <label className="text-xs font-semibold text-muted-foreground" htmlFor="name">Name (optional)</label>
          <Input
            id="name"
            data-testid="register-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="h-11 mt-1"
          />
        </div>
        <div>
          <label className="text-xs font-semibold text-muted-foreground" htmlFor="email">Email</label>
          <Input
            id="email"
            data-testid="register-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="h-11 mt-1"
          />
        </div>
        <div>
          <label className="text-xs font-semibold text-muted-foreground" htmlFor="password">Password</label>
          <Input
            id="password"
            data-testid="register-password"
            type="password"
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="h-11 mt-1"
          />
          <p className="text-[11px] text-muted-foreground mt-1">Minimum 8 characters.</p>
        </div>
        {error && (
          <div className="text-sm text-terracotta-700 bg-[#FDF3F0] rounded-md px-3 py-2" data-testid="register-error">
            {error}
          </div>
        )}
        <button
          type="submit"
          data-testid="register-submit"
          disabled={busy}
          className="w-full h-11 rounded-full bg-terracotta-500 text-white text-sm font-medium hover:bg-terracotta-600 disabled:opacity-60"
        >
          {busy ? "Creating…" : "Create account"}
        </button>
        <div className="text-xs text-muted-foreground text-center">
          Already have an account?{" "}
          <Link to="/login" data-testid="register-login-link" className="text-teal-800 font-semibold">Log in</Link>
        </div>
      </form>
    </div>
  );
}
